import { useState, useEffect } from 'react'

/**
 * Return whether the given time has passed since the first invocation of this hook
 *
 * Note: changing the value of ms between re-render has no effect
 */
export function useTimePassed(ms?: number) {
  const [timePassed, setTimePassed] = useState(false)

  useEffect(() => {
    if (!ms) {
      setTimePassed(true)
      return
    }
    const timeoutRef = setTimeout(() => setTimePassed(true), ms)
    return () => {
      clearTimeout(timeoutRef)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return timePassed
}
